import { useQuery } from '@tanstack/react-query';

import { getNotifications } from '../api';
import { homeQuery } from '../data/query-keys';
import { Notification } from '../types/notifications';

export const useNotifications = () => {
  return useQuery<Notification[], Error>({
    queryKey: homeQuery.getNotifications,
    queryFn: getNotifications,
    staleTime: 5000,
  });
};
